//
// SASS
//

import './component.scss';
